<template>
  <div class="about">
    <h1>You have been signed out.</h1>
  </div>
</template>
<script>
  import { Auth } from 'aws-amplify';

  export default {
		async beforeCreate() {
      this.$store.dispatch('SIGNED_IN', false);

      console.log('signing out user.');
			await Auth.signOut();
		}
	}

</script>
